<script>
import Product from "@/views/modules/products/Product.vue"

export default {
  name: "ProductPage",
  components: {
    Product
  }
}
</script>

<template>
  <div>
    <Product lang="EN" />
  </div>
</template>

<style scoped>
</style>
